<template>
  <div class="pdf-container" v-loading="loading">
    <div :id="id" :ref="`mycanvas_${id}`" v-if="isLocalFile"></div>
    <iframe :src="pdfUrl" frameborder="0" v-else></iframe>
  </div>
</template>

<script>
import PDFJS from '@@/pdf/build/pdf'
import workerSrc from '@@/pdf/build/pdf.worker'
export default {
  name: 'yblPdf',
  props: {
    src: { // pdf路径
      type: String,
      default: () => ''
    },
    scale: { // 放大倍数
      type: Number,
      default: () => 1
    },
    id: {
      type: String,
      default: () => 'mycanvas'
    }
  },
  data () {
    return {
      loading: false,
      pdfUrl: ''
    }
  },
  created () {
    // this.pdfUrl = this.getPdfSrc()
  },
  mounted () {
    // console.log('this.src = ', this.src)
    let _this = this
    if (this.isLocalFile) {
      this.$nextTick(() => {
        _this.getPdf()
      })
    } else {
      this.pdfUrl = this.getPdfSrc()
    }
  },
  computed: {
    isLocalFile () {
      const { src } = this
      return src && src.includes('data:application/pdf;')
    }
  },
  methods: {
    getPage (pdf, pageNumber, container, numPages) { // 获取pdf
      let _this = this
      pdf.getPage(pageNumber).then((page) => {
        let scale = (container.offsetWidth / page.view[2])
        let viewport = page.getViewport(scale * (!_this.scale ? 1 : _this.scale))
        let canvas = document.createElement('canvas')
        canvas.width = viewport.width
        canvas.height = viewport.height
        container.appendChild(canvas)
        let ctx = canvas.getContext('2d')
        var renderContext = {
          canvasContext: ctx,
          transform: [1, 0, 0, 1, 0, 0],
          viewport: viewport,
          intent: 'print'
        }
        page.render(renderContext).then(() => {
          pageNumber += 1
          if (pageNumber <= numPages) {
            _this.getPage(pdf, pageNumber, container, numPages)
          }
        }).then(() => {
          _this.loading = false
        })
      })
    },
    getPdf () {
      // 此中方式接受流形式返回
      this.$refs[`mycanvas_${this.id}`].scrollTop = 0
      if (!this.src) {
        return
      }
      let self = this
      this.loading = true
      let url = this.src// 'http://image.cache.timepack.cn/nodejs.pdf'
      url = url.replace(/http(s)*:\/\/f4.youbaolian.cn/, '/pdf')
      let pdfjsLib = PDFJS
      pdfjsLib.PDFJS.workerSrc = workerSrc// '/static/pdf/build/pdf.worker.js'
      let loadingTask = pdfjsLib.getDocument(url)
      loadingTask.promise.then((pdf) => {
        let numPages = pdf.numPages
        let container = document.getElementById(this.id)
        let pageNumber = 1
        this.getPage(pdf, pageNumber, container, numPages)
      }, function (reason) {
        self.loading = false
        alert(reason)
      })
    },
    getPdfSrc () {
      if (!this.src) {
        return
      }
      // this.loading = true
      let url = this.src// 'http://image.cache.timepack.cn/nodejs.pdf'
      url = url.replace(/http(s)*:\/\/f4.youbaolian.cn/, '/pdf')
      return url
    }
  }
}
</script>

<style lang="less">
.pdf-container{
  position: relative;
  height: 100%;
  iframe{
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pdf.vue